import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// import DownloadTable from './../pages/Download'
import lazyLoad from './utils/lazyLoad';

export const rootRouter = [
	// {
	// 	path: "/",
	// 	element: <Navigate to="/login" />
	// },
	{
		path: "/test",
		element: lazyLoad(React.lazy(() => import("./../pages/Home"))),
		label:"Home"
		// handle:{
		// 	requiresAuth: false
		// }
	},


	{
		path: "/",
		element: lazyLoad(React.lazy(() => import("./../pages/Home"))),
		label:"Home"
		// handle:{
		// 	requiresAuth: false
		// }
	},


	// route for other page to nav to
	// {
	// 	path: "/download",
	// 	element: lazyLoad(React.lazy(() => import("./../pages/Download"))),
	// 	// imported component
	// 	label:"Download"
	// 	// handle:{
	// 	// 	requiresAuth: true
	// 	// }
	// }
];

const Router = () => {
	const routes = useRoutes( rootRouter );
	return routes;
};

export default Router;
